export default {
    AddingAnInternalReturnRefundDoc: {
        Associate: '关联销售单',
        Select: '选择关联销售单',
        Basic: '基础信息',
        Return: '退货单类型',
        type: '退货类型',
        Tripartite: '三方退货单号',
        Third: '三方退货时间',
        reason: '退货原因',
        stage: '退货阶段',
        Customer: '客服备注',
        Financial: '财务信息',
        Settlement: '结算方式',
        Logistics: '物流信息',
        Receiving: '收货仓库',
        information: '退货物流信息',
        selectcompany: '请选择物流公司',
        enterexpress: '请输入快递单号',
        Product: '商品信息',
        Add: '添加退货商品',
        Picture: '图片附件',
        Selectsales: '选择关联销售单',
        Selectproduct: '选择退货退款的商品',
        Associated: '关联销售单：',
        Other: '其它',
        Quantity: '已发货数量：',
        Returned: '已退货数量：',
        Returnable: '可退货数量：',
        Shipment: '发货状态：',
        Preemption: '预占状态：',
        Sourcing: '寻源状态：',
        Please: '请选择退货单类型',
        selecttype: '请选择退货类型',
        enterparty: '请输入三方退货单号',
        selecttime: '请选择三方退货时间',
        selectreason: '请选择退货原因',
        selectstage: '请选择退货阶段',
        selectmethod: '请选择结算方式',
        selectwarehouse: '请选择收货仓库',
        selectstatus: '请选择仓库收货状态',
        DelDeleteete: '删除',
        form: {
            Giveaway: '是否赠品',
            Product: '商品行数量',
            Returnable: '可退货数量',
            Return: '退货数量',
            Refund: '退款单价',
            Total: '退款合计',
        },
        info: {
            selectsales: '请先选择关联销售单',
            add: '请先添加退货商品',
            Please: '请输入退货物流单号',
            The: '退货物流单号不能重复',
            Deletion: '删除成功',
            returnable: '可退货数量为0',
            returned: '返回数据为空，请联系管理员',
        },
    }
};
